<template>

    <div>
        <app-page-header></app-page-header>
        <v-container grid-list-xl>
            <!-- kriterij iskanja -->
            <v-layout row wrap align-left justify-space-around fill-height>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-card>
                        <v-card-title>
                            <span class="subtitle-1"><v-icon left>mdi-filter</v-icon> Kriterij iskanja</span>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="card1 = !card1">
                                <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider v-show="card1"></v-divider>
                        <v-card-text v-show="card1">
                            <!-- članarina -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row wrap justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Tip članarine</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                        v-model="selectedMembershipFees"
                                        :items="membershipFees"
                                        label="Izberi tip članarine"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        prepend-icon="mdi-monitor-star"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        dense
                                        no-data-text="Ni podatkov za prikaz"
                                    ></v-select>   
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <!-- tip člana -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row wrap justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Tip člana</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                        v-model="selectedMemberTypes"
                                        :items="memberTypes"
                                        label="Izberi tip člana"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        prepend-icon="mdi-monitor-star"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        dense
                                        no-data-text="Ni podatkov za prikaz"
                                    ></v-select>   
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <!-- vrsta člana
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row wrap justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Vrsta člana</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                        v-model="selectedMemberClassifications"
                                        :items="memberClassifications"
                                        label="Izberi vrsto člana"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        prepend-icon="mdi-monitor-star"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        dense
                                        no-data-text="Ni podatkov za prikaz"
                                    ></v-select>   
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            -->

                            <!-- spol -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row wrap justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Spol člana</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                        v-model="selectedGender"
                                        :items="gender"
                                        label="Izberi spol člana"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        prepend-icon="mdi-monitor-star"
                                        item-value="id"
                                        item-text="name"
                                        return-object
                                        dense
                                        no-data-text="Ni podatkov za prikaz"
                                    ></v-select>   
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <!-- pošta -->
                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row wrap justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-7 pl-0"><strong>Pošta</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                        v-model="selectedPostcodes"
                                        :items="postcodes"
                                        label="Izberi pošto"
                                        multiple
                                        chips
                                        clearable
                                        deletable-chips
                                        prepend-icon="mdi-monitor-star"
                                        item-value="id"
                                        item-text="code_and_name"
                                        return-object
                                        dense
                                        no-data-text="Ni podatkov za prikaz"
                                    ></v-select>   
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-5 pl-0"><strong>Izberi leto plačane članarine</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                        prepend-icon="mdi-monitor-star"
                                            :items="years"
                                            label="Izberi leto"
                                            v-model="paidYears"
                                            persistent-hint
                                            clearable
                                            multiple
                                            chips
                                            deletable-chips
                                            dense
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container grid-list-xl text-x-center align-center class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-5 pl-0"><strong>Izberi leto neplačane članarine</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                        prepend-icon="mdi-monitor-star"
                                            :items="years"
                                            label="Izberi leto"
                                            v-model="unpaidYears"
                                            persistent-hint
                                            clearable
                                            multiple
                                            chips
                                            deletable-chips
                                            dense
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container grid-list-xl text-x-center align-center class="container--filters--2" style="margin-bottom:-30px;">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-6 pl-0"><strong>Aktivni člani</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-checkbox @change="displayResults" class="ti" v-model="membershipActive" :label="`Prikaži samo aktivne člane: ${checkboxActiveMembersLabel}`"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container grid-list-xl text-x-center align-center class="container--filters--2" style="margin-bottom:-20px;">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-6 pl-0"><strong>Neveljavna članarina</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-checkbox @change="displayResults" class="ti" v-model="forbiddenMembership" :label="`Prikaži samo z neveljavno članarino: ${checkboxForbiddenMembershipLabel}`"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container grid-list-xl text-x-center align-center  class="container--filters">
                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pt-6 pl-0"><strong>Skeniraj kartico</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-btn v-if="$vuetify.breakpoint.smAndDown" class="mt-3" @click="clickToScan" v-show="!displayScanNrInput" color="warning" block dark>Klikni tukaj za skeniranje</v-btn>
                                        <v-btn v-else class="mt-3" @click="clickToScan" v-show="!displayScanNrInput" color="warning" dark small><v-icon small left>mdi-wifi</v-icon>Klikni tukaj za skeniranje</v-btn>
                                        <!--<v-checkbox @change="displayResults" class="ti" v-model="blocked_users" :label="`Prikaži samo blokirane kartice: ${checkboxBlockedCardsOnlyLabel}`"></v-checkbox>-->
                                        <v-form ref="form"
                                        v-model="form"
                                        append>
                                            <v-text-field
                                                v-model="scan_nr"
                                                label="Prisloni kartico na optični čitalnik...."
                                                v-show="displayScanNrInput"
                                                ref="scan_input"
                                                @keydown.enter.prevent="scanCard"
                                                id="scanInputField"
                                                class="ml-4 cb"
                                            ></v-text-field>
                                            
                                        </v-form>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-divider v-if="card1">
                        </v-divider>
                        <span v-if="card1">
                            <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                            <v-btn   @click="search()" color="secondary" dark  block outlined style=""><v-icon left>mdi-magnify</v-icon>Prikaz rezultatov&nbsp;</v-btn><br>
                            <v-btn v-if="checkApplicationPermissions(['sobec-export-members'])"   @click="exportData()" color="secondary" dark  block outlined style=""><v-icon left>mdi-export</v-icon>Izvoz&nbsp;</v-btn>
                            </v-card-text>
                            <v-card-text v-else>
                                <v-btn  @click="search()" color="secondary" dark text><v-icon left>mdi-magnify</v-icon>Prikaz rezultatov&nbsp;</v-btn>
                                <v-btn v-if="checkApplicationPermissions(['sobec-export-members'])"  @click="exportData()" color="secondary" dark text><v-icon left>mdi-export</v-icon>Izvoz&nbsp;</v-btn>
                            </v-card-text>
                        </span>
                    </v-card>
                </v-flex>
            </v-layout>
            <br>
            <members-data-table
            :settings="dataTableSettings"
            :queryParameters="queryParameters"
            ></members-data-table> 

            <data-table-toggle-columns
            :dataTableId="dataTableSettings.id"
            :columns="dataTableSettings.headers"
            :dataTableColumnsMenuId="dataTableSettings.eventBus.toggleColumnsId"

            ></data-table-toggle-columns>
        </v-container>
    </div>
</template>

<script>
import { EventBus } from '@/main.js'
import { getCurrentDate, getCurrentTime, formatDate, getUserApplicationRole, getUserApplicationPermissions, checkPermissions } from '@/helpers/utilities'
const MembersDataTable = () => import('@/components/MembersDataTable.vue')
const DataTableToggleColumns = () => import('@/components/DataTableToggleColumns.vue')
import { isMobileDevice } from '@/helpers/utilities.js'
import { addExportToQueue } from '@/helpers/services.js'



export default 
{
    components: {
        MembersDataTable,
        DataTableToggleColumns
    },

    data: () => ({
        card1: true,
        card2: true,
        form: true,
        card_id: null,

        postcodes: [],
        gender: [],
        membershipFees: [],
        memberTypes: [],
        memberClassifications: [],
        years: [],

        activeMembers: false,
        membershipFeePayments: false,

        selectedPostcodes: [],
        selectedGender: [],
        selectedMemberTypes: [],
        selectedMembershipFees: [],
        selectedMemberClassifications: [],
        paidYears: [],
        unpaidYears: [],
        membershipActive: false,
        forbiddenMembership: false,
        scan_nr: null,
        scan_btn: true,


        dataTableSettings: {
            id: 'dtEvents',
            title: 'Seznam članov',
            sortColumn: ['id'],
            sortDirection: ['desc'],
            progressHeight: 4,
            headers: [
                { text: "ID", value: "id", class: "text-xs-left", visibility: true},
                { text: "Ime in priimek", value: "name", class: "text-xs-left", visibility: true},
                { text: "Naslov", value: "full_address", class: "text-xs-left", visibility: true},
                { text: "Kraj", value: "town", class: "text-xs-left", visibility: true},
                { text: "Pošta", value: "postcode", class: "text-xs-left", visibility: true},
                ///{ text: "Spol", value: "gender", class: "text-xs-left", visibility: true},
                //{ text: "GSM", value: "phone_number", class: "text-xs-left", visibility: true},
                //{ text: "Email", value: "email", class: "text-xs-left", visibility: true},
                //{ text: "Davčna številka", value: "tax_number", class: "text-xs-left", visibility: true},
                { text: "Tip člana", value: "member_type", class: "text-xs-left", visibility: true},
                //{ text: "Vrsta člana", value: "member_classification", class: "text-xs-left", visibility: true},
                { text: "Članarina", value: "membership_fee", class: "text-xs-left", visibility: true},
                { text: "Datum pridružitve", value: "date_of_registration_formatted", class: "text-xs-left", visibility: true},
                { text: "Upravljanje", value: "action", align: "right", class: "text-xs-right", sortable: false, visibility: true, permissions:['sobec-create-member', 'sobec-update-member', 'sobec-delete-member', 'sobec-view-member']},
            ],
            updateInterval: true,
            rowsPerPage: 10,
            endpoint: 'sobec/members',
            editItem: {
                route: 'edit_member',
                routeParameterValue: 'uuid'
            },
            viewItem: {
                route: 'view_member',
                routeParameterValue: 'uuid'
            },
            deleteItem: {
                vuexAction: 'DELETE_MEMBER',
                replaceStrWithColumnValue: 'name',
                confirmationText : "Sta prepričani da želite odstraniti člana {str_to_replace} ?",
                dialogConfirmSuccessText: 'Član {str_to_replace} je bil uspešno odstranjen.',
                dialogConfirmFailText: 'Pri odstranjevanju člana {str_to_replace} je prišlo do napake. Poskusite ponovno.'
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: true,
                    addNewRoute: 'add_member',
                    toggleColumns: true
                }
            },

            selectItems: {
                enabled: false,
                singleSelect: false
            },

            eventBus: {
                refreshDataTable: 'refresh_dt_members',
                totalItems : {
                    event: ''
                },
                search: 'dt-rfid-members-search',
                toggleColumnsId: 'toggle-rfid-members-list-columns',
                selectedItems: '',
                removeSelectedItems: ''
            }


        }
    }),

    watch: {

    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        queryParameters() {
            return {
                selectedPostcodes: this.selectedPostcodes.map(item => item.id),
                selectedGender: this.selectedGender.map(item => item.id),
                selectedMemberTypes: this.selectedMemberTypes.map(item => item.id),
                selectedMemberClassifications: this.selectedMemberClassifications.map(item => item.id),
                membershipActive: this.membershipActive,
                selectedMembershipFees: this.selectedMembershipFees.map(item => item.id),
                paidYears: this.paidYears,
                unpaidYears: this.unpaidYears,
                forbiddenMembership: this.forbiddenMembership

            }
        },

        checkboxMembershipFeePaymentLabel() {
            if(this.membershipFeePayments) {
                return 'DA'
            }

            return 'NE'
        },

        checkboxActiveMembersLabel() {
            if(this.membershipActive) {
                return 'DA'
            }

            return 'NE'
        },

        checkboxForbiddenMembershipLabel() {
            if(this.forbiddenMembership) {
                return 'DA';
            }

            return 'NE';
        },

        displayScanNrInput() {
            if(!this.scan_btn) {
                return true
            }

            return false
        }
    },

    methods: {
        checkApplicationPermissions(requiredPermissions) {
            return checkPermissions(requiredPermissions, getUserApplicationPermissions())
        },

        search() {
            setTimeout(() => {
                EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            }, 250)
        },

        exportData() {
            window.console.log("exporting data ...");
            let parameters = {
                selectedPostcodes: this.selectedPostcodes.map(item => item.id),
                selectedGender: this.selectedGender.map(item => item.id),
                selectedMemberTypes: this.selectedMemberTypes.map(item => item.id),
                selectedMemberClassifications: this.selectedMemberClassifications.map(item => item.id),
                membershipActive: this.membershipActive,
                selectedMembershipFees: this.selectedMembershipFees.map(item => item.id),
                paidYears: this.paidYears,
                unpaidYears: this.unpaidYears,
                forbiddenMembership: this.forbiddenMembership
            }
            
            addExportToQueue('members', parameters);
        },

        displayResults() {
            setTimeout(() => {
                EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            }, 280)
        },

        clickToScan() {
            this.scan_nr = null
            this.scan_btn = false
            this.setFocus()
            var vm = this
        },

        setFocus() {
            if(!this.scan_btn) {
                var vm = this
                setTimeout(() => {
                    vm.$refs.scan_input.focus()
                }, 250)
            }
        },

        scanCard() {
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)

            EventBus.$emit(this.dataTableSettings.eventBus.search, vm.scan_nr.toString());
            this.scan_nr = null
            this.scan_btn = true
            vm.$store.commit('SET_PROGRESS', false)
            setTimeout(() => {
                vm.search()
            }, 250)
        }
    },
    
    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        if(isMobileDevice(this)) {
            this.card1 = false
        }
    },

    mounted() {
        var vm = this
        vm.$store.commit('SET_PROGRESS', true)
        vm.$store.dispatch('PARAMETERS_DATA')
        .then(response => {
            //window.console.log(response.data)
            vm.gender = response.data.gender
            vm.postcodes = response.data.postcodes
            vm.memberTypes = response.data.memberTypes
            vm.memberClassifications = response.data.memberClassifications
            vm.membershipFees = response.data.membershipFees
            vm.years = response.data.years
        })
        .catch(error => {
            window.console.error("### ERROR Members.vue@mounted ###");
            window.console.error(error)
        })
        .finally(() => {
            vm.$store.commit('SET_PROGRESS', false)
        })
    },

    beforeDestroy() {
        EventBus.$off(this.dataTableSettings.id)
        EventBus.$off(this.dataTableSettings.eventBus.refreshDataTable)
        EventBus.$off(this.dataTableSettings.eventBus.search)
    }
}

</script>